// Service level root cause constants
import { getPeriodOfTimeInSeconds } from "apm/helpers/time";

export const AT_HOST_TAG = "@host";
export const HOST_RESPONSE_TIME_TRESHOLD = 100;
export const HOST_REQUEST_RATE_TRESHOLD = 25;
export const SERVICE_NAME_TAG = "service";
export const WARNING_TRESHOLD_IN_PERCENT = 10;
export const PROBLEM_LAYER_METRIC =
  "trace.service.critical_path.response_time_per_trace";
export const PROBLEM_LAYER_METRIC_GROUP_BY = ["layer_name", "layer_type"];
export const WEEK_IN_SECONDS = getPeriodOfTimeInSeconds(7, "days");
export const HOUR_IN_SECONDS = getPeriodOfTimeInSeconds(1, "hours");
export const LATENCY_TRESHOLD = -50;
export const INFO = "info";
export const WARNING = "warning";

export const propblemLayerEnum = {
  PROBLEM_LAYER_APPLICATION: "application",
  PROBLEM_LAYER_CACHE: "cache",
  PROBLEM_LAYER_DATABASE: "database",
  PROBLEM_LAYER_OTHER_REMOTE_SERVICE: "non_instrumented_remote_service",
  PROBLEM_LAYER_INSTRUMENTED_REMOTE_SERVICE: "instrumented_remote_service",
  PROBLEM_HIGHER_REQUEST_HOST: "higher_request-host",
  PROBLEM_HIGHER_RESPONSE_HOST: "higher_response-host",
};

export const apmTabEnum = {
  OVERVIEW: {
    value: "",
    label: "Overview",
  },
  DETAILS: {
    value: "details",
    label: "Details",
  },
  TRANSACTIONS: {
    value: "transactions",
    label: "Transactions",
  },
  REMOTE_SERVICES: {
    value: "remote",
    label: "Remote Services",
  },
  DATABASES: {
    value: "databases",
    label: "Databases",
  },
  CACHES: {
    value: "caches",
    label: "Caches",
  },
  EXCEPTIONS: {
    value: "exceptions",
    label: "Exceptions",
  },
  SUMMARY: {
    value: "summary",
    label: "Summary",
  },
};

export const detailsTabEnum = {
  PROFILE: {
    value: "profile",
    label: "Code Profile",
  },
  ERRORS: {
    value: "errors",
    label: "Errors",
  },
  QUERIES: {
    value: "queries",
    label: "Queries",
  },
  RAWDATA: {
    value: "rawdata",
    label: "Raw Data",
  },
  BACKTRACES: {
    value: "backtraces",
    label: "Backtraces",
  },
};

export const exceptionsTabEnum = {
  BACKTRACES: {
    value: "backtraces",
    label: "Backtraces",
  },
  INFO: {
    value: "info",
    label: "Info",
  },
};
